import { render, staticRenderFns } from "./budget-upload.vue?vue&type=template&id=60135ec0&scoped=true&"
import script from "./budget-upload.vue?vue&type=script&lang=ts&"
export * from "./budget-upload.vue?vue&type=script&lang=ts&"
import style0 from "./budget-upload.vue?vue&type=style&index=0&id=60135ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60135ec0",
  null
  
)

export default component.exports